// GENERATED by tools/scripts/generate-icons.mjs from libs/icons/svg/outline/arrow-right.svg. Do not edit.

import { glyph } from '@gto/icons/glyphs/outline/arrow-right'

import { Icon, type IconComponentProps } from '../icon'

export const ArrowRightIcon = (props: IconComponentProps) => (
  <Icon
    glyph={glyph}
    {...props}
  />
)
